import { BookStore } from "../../flux";
const gadgetId = "mcgraw-hill-redi";

const launchMcGrawHillRedi = isbn => {
  Fraction.Helpers.Locations.safeRedirect(`https://redi.mcgrawhill.com/?utm_medium=referral&utm_source=vital-source&utm_campaign=redi+awareness&utm_content=[${isbn}]`, "_blank");
};

const isEnabled = isbn => {
  const book = BookStore.get(isbn);
  const mcgrawHillFeatureFlag =
    book.features &&
    book.features.some(f => f.name.toLowerCase() === "mcgrawhillredi");
  return Fraction.Brand.McgrawHillRedi.enabled && mcgrawHillFeatureFlag;
};

module.exports = {
  metadata: () => ({
    id: gadgetId,
    name: "McGraw-Hill Redi",
    learnMore: false,
    launch: "// TODO",
    toggle: false,
    expanded: false,
    type: "panel",
    autoShow: false,
    enabled: isEnabled,
    hideInMobile: true,
    sidebar: {
      icon: "/img/mcgraw-hill/mhe-redi-avatar-photo-round.svg",
      activeMethod: "fill", // 'fill' or 'highlight'
      action: launchMcGrawHillRedi
    }
  })
};
